/* eslint-disable */
import { callingSettingsMessages } from '@ringcentral-integration/commons/modules/CallingSettings';
export default {
  [callingSettingsMessages.saveSuccess]: '設定已成功儲存。',
  [callingSettingsMessages.saveSuccessWithSoftphone]:
    '設定已成功儲存。請確定您在電腦上已安裝 {brand}。',
  [callingSettingsMessages.permissionChanged]:
    '您的權限最近已變更。請前往 {link} 以檢查您的通話選項。',
  [callingSettingsMessages.phoneNumberChanged]:
    '您的電話號碼資訊最近已變更。請前往 {link} 並檢查您的通話選項。',
  link: '[設定] > [通話]',
  [callingSettingsMessages.webphonePermissionRemoved]:
    '您的權限已變更，而您無法使用瀏覽器進行通話。如需詳細資訊，請聯絡您的帳戶管理員。',
  [callingSettingsMessages.emergencyCallingNotAvailable]:
    '不支援撥打緊急或特殊服務號碼。在發生緊急狀況時，請使用您的傳統有線線路或無線電話撥打緊急電話。',
  [callingSettingsMessages.saveSuccessWithJupiter]:
    '設定已成功儲存。請確定您在電腦上已安裝 {brand}。',
  [callingSettingsMessages.disableEmergencyInJapan]: '日本無法使用緊急服務。',
} as const;

// @key: @#@"[callingSettingsMessages.saveSuccess]"@#@ @source: @#@"Settings saved successfully."@#@
// @key: @#@"[callingSettingsMessages.saveSuccessWithSoftphone]"@#@ @source: @#@"Settings saved successfully. Please make sure you have {brand} installed in your computer."@#@
// @key: @#@"[callingSettingsMessages.permissionChanged]"@#@ @source: @#@"Your permissions have been changed recently. Please go to {link} to check your Calling options."@#@
// @key: @#@"[callingSettingsMessages.phoneNumberChanged]"@#@ @source: @#@"Your phone number information has been changed recently. Please go to {link} to check your Calling options."@#@
// @key: @#@"link"@#@ @source: @#@"Settings > Calling"@#@
// @key: @#@"[callingSettingsMessages.webphonePermissionRemoved]"@#@ @source: @#@"Your permissions have been changed and you cannot make calls with Browser. For details please contact your account administrator."@#@
// @key: @#@"[callingSettingsMessages.emergencyCallingNotAvailable]"@#@ @source: @#@"Dialing emergency or special service numbers is not supported. In an emergency, use your traditional wireline or wireless phone to call an emergency number."@#@
// @key: @#@"[callingSettingsMessages.saveSuccessWithJupiter]"@#@ @source: @#@"Settings saved successfully. Please make sure you have {brand} installed in your computer."@#@
// @key: @#@"[callingSettingsMessages.disableEmergencyInJapan]"@#@ @source: @#@"Emergency service is not available in Japan."@#@
